'use client'
import React, { useContext } from 'react'

import './Header.scss'
import useResizeWidth from 'controller/useResizeWidth'
import { ActionContext } from 'controller/context/ActionProvider'

// const arrMenu = [
//   {
//     title: 'Utilities',
//     status: 'utilities',
//   },
//   {
//     title: 'OUR Manifesto',
//     status: 'manifesto',
//   },
// ]

function HeaderStableCoin() {
  const { positionY, isMobile } = useResizeWidth()
  const { state, setState } = useContext(ActionContext)
  const { isVideoPlaying } = state
  const { setStatusChoose } = setState
  // const [isShowMenu, setIsShowMenu] = React.useState(false)

  // const onShowMenu = () => {
  //   setIsShowMenu(!isShowMenu)
  // }

  const onScrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <div
      className={`header-stable-coin-wrapper ${
        !isVideoPlaying && 'header-stable-coin-wrapper--show'
      } ${positionY >= 500 && 'header-stable-coin-wrapper--background'}`}>
      <div className='header-container'>
        {/* <div
          className={`icon-${isShowMenu ? 'ic-cancel' : 'ic-menu'} menu`}
          onClick={onShowMenu}></div> */}

        {/* <div className={`header-left ${isShowMenu && 'header-left--show'}`}>
          {arrMenu.map((item, index) => {
            return (
              <div
                className='item-menu'
                key={index}
                onClick={() => {
                  setStatusChoose(item.status)
                  setIsShowMenu(false)
                }}>
                {item.title}
              </div>
            )
          })}
        </div> */}

        <div className='logo-box' onClick={onScrollTop}>
          <span
            className={`icon-${
              isMobile ? 'web_logo' : 'logo-full'
            } logo`}></span>
        </div>

        <div className='header-right'>
          <div
            className='right-item'
            onClick={() => setStatusChoose('localMoney')}>
            Start Using
          </div>

          <div
            className='right-item'
            onClick={() => setStatusChoose('buildUs')}>
            Build with us
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderStableCoin
